<template>
  <div class="landing-page">
    <div class="landing-content">
      <h1>Remote Camera Decision Support Tool</h1>
      
      <div class="description">
        <p>
          The Remote Camera Decision Support Tool is an interactive, survey-based resource designed to help users, 
          especially those new to wildlife monitoring, plan effective and defensible remote camera studies. Developed 
          by the Remote Camera Steering Committee (RCSC) in partnership with the Alberta Biodiversity Monitoring 
          Institute (ABMI), the tool guides users through a structured series of multiple-choice questions to clarify 
          project goals, available inventory, logistical considerations, and methodological needs.
        </p>
        <p>
          In five minutes or less, users can identify the purpose of their camera deployment (e.g., occupancy, 
          distribution, detection of rare species, relative abundance), reflect on sampling constraints, and consider 
          study design trade-offs. Based on their responses, the tool generates a customized recommendation report 
          that outlines suggested sampling approaches, deployment considerations, and relevant methodological guidance. 
          The report also includes direct links to foundational literature, protocols, and resources referenced in 
          the tool, enabling users to explore best practices in more depth.
        </p>
        <p>
          By offering clear, consistent, and evidence-informed guidance, the Remote Camera Decision Support Tool 
          supports practitioners in designing remote camera programs that enhance data quality, 
          comparability, and long-term monitoring success.
        </p>
      </div>
      
      <button @click="startSurvey" class="start-button">
        Start Survey
      </button>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['start-survey']);

const startSurvey = () => {
  emit('start-survey');
};
</script>

<style scoped>
.landing-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  padding: 20px;
  box-sizing: border-box;
}

.landing-content {
  width: 1250px;
  max-width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 60px 40px;
  text-align: center;
  box-sizing: border-box;
}

h1 {
  color: #1976d2;
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.description {
  text-align: left;
  margin-bottom: 40px;
  line-height: 1.8;
  color: #333;
}

.description p {
  margin-bottom: 20px;
}

.description p:last-child {
  margin-bottom: 0;
}

.start-button {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 16px 48px;
  font-size: 1.1rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.start-button:hover {
  background-color: #1565c0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.start-button:active {
  transform: translateY(1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .landing-content {
    padding: 40px 20px;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
}
</style>
